import { parseNumero } from "./calculos";
import { hasValue } from "./data";
import { F } from "./gerencialFields";

/**
 * Sequência das operações de máquinas: é ela que decide em que etapa um
 * ambiente está parado (a primeira operação ainda sem data).
 *
 * 2026-09-24: corte → furação → bordo, a mesma ordem das colunas. Com corte →
 * bordo → furação, um ambiente só com corte aparecia "Aguardando bordo" com a
 * furação — coluna anterior na tela — ainda vazia. Na planilha as duas andam
 * juntas (maioria no mesmo dia; quando não, a furação vem antes mais vezes).
 *
 * Usinagem (coluna BF da planilha) saiu do bloco de máquinas em 2026-08-18 — o
 * dado continua na planilha para histórico, mas não gera mais pendência aqui.
 */
export const SEQUENCIA_MAQUINAS = [
  { chave: "corte", titulo: "Corte", campo: F.DATA_DE_CORTE, aguardando: "Aguardando corte" },
  { chave: "furacao", titulo: "Furação", campo: F.DATA_DE_FURACAO, aguardando: "Aguardando furação" },
  { chave: "bordo", titulo: "Bordo", campo: F.DATA_DE_BORDO, aguardando: "Aguardando bordo" },
];

/**
 * Ordem em que as colunas aparecem no board, da esquerda para a direita.
 * Continua separada da sequência por ser layout, mas as duas têm de coincidir:
 * coluna à frente de uma etapa vazia é incoerente (teste trava).
 */
export const ORDEM_COLUNAS_MAQUINAS = ["corte", "furacao", "bordo"];

export const OPERACOES_MAQUINAS_POR_CHAVE = SEQUENCIA_MAQUINAS.reduce(
  (acumulador, operacao) => ({ ...acumulador, [operacao.chave]: operacao }),
  {}
);

/** Colunas do board já na ordem de exibição. */
export function getColunasMaquinas() {
  return ORDEM_COLUNAS_MAQUINAS.map((chave) => OPERACOES_MAQUINAS_POR_CHAVE[chave]);
}

/** Primeira operação da sequência que ainda não tem data. `null` = concluído. */
export function getOperacaoPendente(row) {
  return SEQUENCIA_MAQUINAS.find((operacao) => !hasValue(row[operacao.campo])) ?? null;
}

export function isIndustrializacaoPending(row) {
  return hasValue(row[F.MDF_BORDO]) && getOperacaoPendente(row) !== null;
}

export function getIndustrializacaoDeadline(row) {
  return row[F.FINAL_MAQUINAS] ||
    row[F.DATA_REPROGRAMADA] ||
    row[F.ENTREGA_PREVISTA] ||
    null;
}

export function getIndustrializacaoRowState(row) {
  const pendente = getOperacaoPendente(row);
  return pendente ? pendente.aguardando : "Máquinas concluídas";
}

export function formatLoteLabel(value) {
  const numero = parseNumero(value);

  if (numero !== null) {
    return `Lote ${String(Math.trunc(numero)).padStart(3, "0")}`;
  }

  const texto = String(value ?? "").trim();
  return texto ? `Lote ${texto}` : "Lote sem número";
}
